import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify);

export default new Vuetify({
  rtl: true,
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#001554",
        secondary: "#595959",
        accent: "#00796B",
        third: "#c30000",
        error: "#fd397a",
        info: "#5578eb",
        success: "#0abb87",
        warning: "#ffb822",
        orange: "#e87520",
      }
    },
  },
});
